<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">My support tickets</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">

                        <div class="card card-bordered">
                            <div class="card-inner ">
                                <div class="preview-block">
                                    <div class="row gy-4">
                                        <div class="col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                            Subject
                                        </div>
                                        <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
                                            {{newTicketDetail.subject}}
                                        </div>
                                        <div class="col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                            Number
                                        </div>
                                        <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
                                            {{newTicketDetail.code}}
                                        </div>


                                        <div class="col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                            Date opened
                                        </div>
                                        <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
                                            {{getDate(newTicketDetail.date)}}
                                        </div>
                                        <div class="col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                            Status
                                        </div>
                                        <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
                                            <span v-if="newTicketDetail.status" class="badge badge-dot bg-info">Processing</span>
                                            <span v-else class="badge badge-dot bg-danger">Close</span>
                                        </div>


                                        <div class="col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                            Description
                                        </div>
                                        <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
                                            {{newTicketDetail.description}}
                                        </div>
                                        <div class="col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                            Latest modification
                                        </div>
                                        <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
                                            {{getDate(newTicketDetail.lastUpdate)}}
                                        </div>
                                    </div>

                                    <hr class="preview-hr" v-if="!newTicketDetail.status">
                                    <div class="row gy-4" v-if="!newTicketDetail.status">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card card-bordered" v-if="newTicketDetail.status">
                            <div class="card-inner ">
                                <div class="preview-block">
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="form-group">
                                                <label class="form-label">Description</label>
                                                <div class="form-control-wrap">
                                                    <textarea v-model="newTicket.description" class="form-control no-resize"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;"> Send</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>

                                            <button v-on:click="CloseTicket()" class="btn btn-info" style="margin-right: 10px;float:right;">Close</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card card-bordered" v-for="item in newTicketDetail.supportTicketChats" :key="item.id">
                            <div class="card-inner ">
                                <div class="preview-block">
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <h6>From : {{item.isFrom? 'Black Stone Capitals' : 'You'}}</h6>
                                            <p class="mt-5 mb-3">{{item.message}}</p>

                                            <strong class="text-right">Date received : {{getDate(item.date)}}</strong>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    import moment from "moment";
    export default ({
        components: {
            Loading
        },
        name: 'newTicket',
        data: function () {
            return {
                loading: false,
                newTicketDetail: '',

                newTicket: {
                    id: '00000000-0000-0000-0000-000000000000',
                    description: '',
                }
            }
        },
        validations: {
            newTicket:
            {
                description:
                {
                    required
                }
            }
        },

        methods: {
            getDate: function (date) {
                return moment(date).format('D-MM-YYYY HH:mm');
            },

            GoToList: function () {
                this.$router.push('/Tickets')
            },
            SaveNewUser: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Support/SaveTicket', this.newTicket, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {

                            root.loading = false;
                            root.$swal({
                                title: 'Submited!',
                                text: response.data.isAddUpdate,
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            CloseTicket: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Support/CloseTicket', this.newTicket, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {

                            root.loading = false;
                            root.$swal({
                                title: 'Close!',
                                text: response.data.isAddUpdate,
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            TicketStatusUpdated: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Support/TicketStatusUpdated?id='+ this.newTicket.id, { headers: { "Authorization": `Bearer ${token}` } });


            },


        },
        created: function () {
            if (this.$route.query.data != undefined) {
                this.newTicketDetail = this.$route.query.data;
                this.newTicket.id = this.$route.query.data.id;

                this.TicketStatusUpdated();
            }
        },
    })
</script>
